import { client } from "@/api/client";
import { JobRepository } from "@/modules/jobs/domain/JobRepository";
import { Job } from "@/modules/jobs/domain/Job";

export class ApiJobRepository implements JobRepository {       
    api_to_domain(line){
        return new Job(line.id, line.state, line.output_info, line.error)
    }
    
    async find_by_id(id: number):Promise<Job|null> {      
      let res  = await client.get(`/jobs/jobs/${id}/`)
      if (res) {
        return this.api_to_domain(res.data)
      }
      else {
        return null;
      }
    }
  }
